import { Text, Icon } from '@cad-arc';
import classNames from 'classnames';
import React from 'react';
import { NarrativeRowNavProps } from '../../hooks/use-narrative-keyboard-nav/use-narrative-keyboard-nav';
import styles from './pinned-divider-row.module.css';

export function PinnedDividerRow({
    hiddenCount,
    isExpanded,
    onToggle,
    rowNavProps,
}: {
    hiddenCount: number;
    isExpanded: boolean;
    onToggle: () => void;
    rowNavProps?: NarrativeRowNavProps;
}): React.JSX.Element {
    return (
        <div
            className={styles['divider']}
            onClick={onToggle}
            data-testid="PINNED_DIVIDER_ROW"
            role="button"
            ref={rowNavProps?.ref}
            tabIndex={rowNavProps ? rowNavProps.tabIndex : 0}
            onFocus={rowNavProps?.onFocus}
            onKeyDown={(e) => {
                rowNavProps?.onKeyDown(e);
                if (e.defaultPrevented) return;
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onToggle();
                }
            }}
        >
            <Text className={styles['toggle-text']}>
                {isExpanded ? 'Show less' : `Expand all pinned (${hiddenCount} more)`}
                <Icon
                    size="sm"
                    icon="TriangleDown"
                    className={classNames(styles['toggle-icon'], {
                        [styles['toggle-icon-expanded']]: isExpanded,
                    })}
                />
            </Text>
        </div>
    );
}
